<template>
  <NotFound />
</template>

<script>
const NotFound = () => import('@/components/NotFound')
import { nameBrand } from '~/util/defaultInfo'

export default {
  name: 'NotFounPage',
  components: {
    NotFound,
  },
  layout: 'main',
  props: {
    error: { type: String },
  },
  head() {
    return {
      title: nameBrand?.toLowerCase(),
      meta: [{ name: 'robots', content: 'noindex, nofollow' }],
    }
  },
}
</script>
